import { render } from "./ShowerHeadType.vue?vue&type=template&id=6d2b900d&scoped=true"
import script from "./ShowerHeadType.vue?vue&type=script&lang=js"
export * from "./ShowerHeadType.vue?vue&type=script&lang=js"

import "./ShowerHeadType.vue?vue&type=style&index=0&id=6d2b900d&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d2b900d"]])

export default __exports__